import axios from "axios";
import { useFormik } from "formik";
import { useWebRouter } from "~utils/next-router/use-web-router";
import {
	toast,
	UpdatePasswordFormValues,
	UpdatePasswordSchema,
	UpdatePassword as View,
} from "ui-components";
import { tryCatch } from "utils";

import { usePageLoaded } from "~auth/hooks/usePageLoaded";
import { useUpdatePassword } from "~auth/queries/useUpdatePassword";

export const UpdatePassword = () => {
	const isPageLoaded = usePageLoaded();
	const router = useWebRouter();
	const updatePassword = useUpdatePassword();
	const form = useFormik<UpdatePasswordFormValues>({
		validateOnMount: true,
		initialValues: {
			password: "",
			retypedPassword: "",
		},
		validationSchema: UpdatePasswordSchema,
		validate(values) {
			return values.password === values.retypedPassword
				? {}
				: { retypedPassword: "Passwords do not match" };
		},
		onSubmit: (values, helpers) => {
			toast.promise(
				async () => {
					const [error] = await tryCatch(updatePassword.mutateAsync(values));
					if (error) {
						helpers.setSubmitting(false);
						throw error;
					}
					void router.replace("/maps");
				},
				{
					loading: "Updating password...",
					success: "Signing you in to your account...",
					error: (e) =>
						axios.isAxiosError(e) ? "Something went wrong!" : e.message,
				},
			);
		},
	});

	if (!isPageLoaded) return null;

	return <View form={form} />;
};
